import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { Component } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import WarningIcon from '@atlaskit/icon/core/migration/warning--editor-warning';
import { N20, N800, Y500 } from '@atlaskit/theme/colors';
import { center, borderRadius } from '@atlaskit/media-ui';
import { defaultImageCardDimensions } from '../../../utils';
import { ContentLoadingErrorMessage } from './contentLoadingErrorMessage';
var isPercentage = function isPercentage(value) {
  return /^\d+(\.\d+)?%$/.test(value);
};
var shouldShowText = function shouldShowText(_ref) {
  var width = _ref.width,
    height = _ref.height;
  if (isPercentage(width) || isPercentage(height)) {
    return false;
  }
  return parseInt(width, 10) >= 240 && parseInt(height, 10) >= 90;
};
var normalizeDimension = function normalizeDimension(value, defaultValue) {
  var sValue = value.toString();
  return isPercentage(sValue) ? sValue : isNaN(parseInt(sValue, 10)) ? defaultValue + 'px' : parseInt(sValue, 10) + 'px';
};
var getConvertedDimension = function getConvertedDimension(dimensions) {
  var _dimensions$width = dimensions.width,
    width = _dimensions$width === void 0 ? defaultImageCardDimensions.width : _dimensions$width,
    _dimensions$height = dimensions.height,
    height = _dimensions$height === void 0 ? defaultImageCardDimensions.height : _dimensions$height;
  return {
    width: normalizeDimension(width, defaultImageCardDimensions.width),
    height: normalizeDimension(height, defaultImageCardDimensions.height)
  };
};
var wrapperStyles = function wrapperStyles() {
  var dimensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultImageCardDimensions;
  try {
    return css(
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    center,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius, {
      background: "var(--ds-background-neutral, ".concat(N20, ")"),
      color: "var(--ds-text-subtle, ".concat(N800, ")"),
      maxHeight: '100%',
      maxWidth: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    getConvertedDimension(dimensions), {
      display: 'flex',
      flexDirection: 'column',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
      p: {
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        textAlign: 'center'
      }
    });
  } catch (e) {
    return null;
  }
};
export var UnhandledErrorCard = /*#__PURE__*/function (_Component) {
  function UnhandledErrorCard() {
    _classCallCheck(this, UnhandledErrorCard);
    return _callSuper(this, UnhandledErrorCard, arguments);
  }
  _inherits(UnhandledErrorCard, _Component);
  return _createClass(UnhandledErrorCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        dimensions = _this$props.dimensions,
        onClick = _this$props.onClick;
      var isErrorHidden = !shouldShowText(getConvertedDimension(dimensions !== null && dimensions !== void 0 ? dimensions : defaultImageCardDimensions));
      return (
        // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlaskit/design-system/consistent-css-prop-usage, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
        jsx("div", {
          css: wrapperStyles(dimensions),
          onClick: onClick
        }, jsx(WarningIcon, {
          label: "Error",
          color: "var(--ds-icon-warning, ".concat(Y500, ")"),
          LEGACY_size: "medium",
          spacing: "spacious"
        }), jsx(ContentLoadingErrorMessage, {
          isHidden: isErrorHidden
        }))
      );
    }
  }]);
}(Component);